var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.74375 9.89162L12.6238 13.7716L16.5037 9.89162C16.8938 9.50162 17.5238 9.50162 17.9138 9.89162C18.3038 10.2816 18.3038 10.9116 17.9138 11.3016L13.3238 15.8916C12.9338 16.2816 12.3038 16.2816 11.9138 15.8916L7.32375 11.3016C6.93375 10.9116 6.93375 10.2816 7.32375 9.89162C7.71375 9.51162 8.35375 9.50162 8.74375 9.89162Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down.35853ad9fc1b27e764c540e58d9d10cb.svg";
export { ForwardRef as ReactComponent };